module.exports = __webpack_public_path__ + "img/listYourSchool.c4d31a0a.svg";